import { render, staticRenderFns } from "./communityReportList.vue?vue&type=template&id=478daffd&scoped=true&"
import script from "./communityReportList.vue?vue&type=script&lang=js&"
export * from "./communityReportList.vue?vue&type=script&lang=js&"
import style0 from "./communityReportList.vue?vue&type=style&index=0&id=478daffd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478daffd",
  null
  
)

export default component.exports